<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <!-- <classifyAndNav />
    <banner/> -->
    <router-view v-if="!isMobileBlocked"></router-view>
    <div v-else class="device-blocked">
      <div class="device-blocked__card">
        <h1 class="device-blocked__title">请使用电脑端打开</h1>
        <p class="device-blocked__desc">当前项目仅支持 PC 和 Mac 浏览器访问。</p>
      </div>
    </div>
    <!-- <login></login> -->
    <!-- <IndividualRegistration></IndividualRegistration> -->
  </div>
</template>

<!-- <script type="text/javascript" src=https://api.map.baidu.com/api?v=2.0&ak=EORBGLTvncfjMQfLb0iqUa8AINOVVDEu">
</script> -->
<script>
// import HelloWorld from './components/HelloWorld.vue'
// import Banner from './components/Banner.vue'
// import ClassifyAndNav from './components/ClassifyAndNav.vue'
// import Login from './views/login/Login.vue'
// import IndividualRegistration from './views/register/IndividualRegistration.vue'
export default {
  name: 'App',
  data() {
    return {
      isMobileBlocked: false
    }
  },
  created() {
    this.isMobileBlocked = this.isUnsupportedMobile()
    if (this.isMobileBlocked) {
      this.$alert('当前项目仅支持 PC 和 Mac 浏览器访问，请使用电脑端打开。', '访问受限', {
        confirmButtonText: '我知道了',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        center: true
      })
    }
  },
  methods: {
    isUnsupportedMobile() {
      const userAgent = navigator.userAgent || ''
      const isAndroid = /Android/i.test(userAgent)
      const isIOS = /iPhone|iPad|iPod/i.test(userAgent)

      return isAndroid || isIOS
    }
  },
  components: {
    // HelloWorld,
    // Banner,
    // ClassifyAndNav
    // Login,
    // IndividualRegistration
  }
}
</script>

<style>
#app {
  font-family:PingFang SC,Helvetica Neue,Helvetica,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif!important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 16px;
  min-width: 1170px;
}

.device-blocked {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  box-sizing: border-box;
  background: #f5f7fa;
}

.device-blocked__card {
  width: 100%;
  max-width: 420px;
  padding: 32px 24px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.device-blocked__title {
  margin: 0 0 12px;
  font-size: 24px;
  color: #303133;
}

.device-blocked__desc {
  margin: 0;
  line-height: 1.6;
  color: #606266;
}
</style>
